/**
 * Slack Twins web paths shared by the backend (which builds the URLs Slack and
 * the OAuth callback send people to) and the frontend (which registers the
 * routes). One source, so the two never drift.
 */

/** Web page that confirms a Slack account link. Carries `?token=`. */
export const SLACK_TWINS_CONNECT_PATH = '/slack/connect';
export const SLACK_TWINS_CONNECT_TOKEN_PARAM = 'token';

/** Query param on the settings page that reports how an install ended. */
export const SLACK_TWINS_INSTALL_RESULT_PARAM = 'slackTwins';

export const SLACK_TWINS_INSTALL_RESULTS = [
  'installed',
  'refused',
  'mismatch',
  'cancelled',
  'expired',
  'failed',
] as const;

export type SlackTwinsInstallResult = (typeof SLACK_TWINS_INSTALL_RESULTS)[number];

/** Settings tab that holds the "Add to Slack" card. */
export const SLACK_TWINS_SETTINGS_TAB = 'skills';

export function slackTwinsConnectPath(token: string): string {
  return `${SLACK_TWINS_CONNECT_PATH}?${SLACK_TWINS_CONNECT_TOKEN_PARAM}=${encodeURIComponent(token)}`;
}

export function slackTwinsInstallResultPath(result: SlackTwinsInstallResult): string {
  return `/settings?tab=${encodeURIComponent(SLACK_TWINS_SETTINGS_TAB)}&${SLACK_TWINS_INSTALL_RESULT_PARAM}=${encodeURIComponent(result)}`;
}

export function isSlackTwinsInstallResult(value: unknown): value is SlackTwinsInstallResult {
  return (
    typeof value === 'string' &&
    (SLACK_TWINS_INSTALL_RESULTS as ReadonlyArray<string>).includes(value)
  );
}

/**
 * Query param on the connect page that reports how the Sign in with Slack step
 * of an account link ended (I4). The backend callback redirects with it.
 */
export const SLACK_TWINS_LINK_RESULT_PARAM = 'slackLink';

export const SLACK_TWINS_LINK_RESULTS = [
  'linked',
  /** Signed in as a different Slack user or workspace than the link was for. */
  'wrong_account',
  /** Callback from another browser or another Fairgen session. */
  'mismatch',
  'cancelled',
  'expired',
  'failed',
  'already_linked',
  'account_linked_elsewhere',
  'wrong_org',
  'workspace_gone',
] as const;

export type SlackTwinsLinkResult = (typeof SLACK_TWINS_LINK_RESULTS)[number];

export function slackTwinsLinkResultPath(result: SlackTwinsLinkResult): string {
  return `${SLACK_TWINS_CONNECT_PATH}?${SLACK_TWINS_LINK_RESULT_PARAM}=${encodeURIComponent(result)}`;
}

export function isSlackTwinsLinkResult(value: unknown): value is SlackTwinsLinkResult {
  return (
    typeof value === 'string' &&
    (SLACK_TWINS_LINK_RESULTS as ReadonlyArray<string>).includes(value)
  );
}
